import { render, staticRenderFns } from "./BusinessLicense.vue?vue&type=template&id=75cadb3a&scoped=true&"
import script from "./BusinessLicense.vue?vue&type=script&lang=js&"
export * from "./BusinessLicense.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLicense.vue?vue&type=style&index=0&id=75cadb3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cadb3a",
  null
  
)

export default component.exports